import React from "react";
import Tooltip from "../../../../../general/tooltip";
import Icon from "../../../../../general/icon";
import Alert from "../../../../../general/alert";
import {TIhioDataAndPrescriptionMedicationItemFields} from "../../../../../../../types/prescription";

type BulkItemCardItemProps = {
    bulkItemFieldValues?: TIhioDataAndPrescriptionMedicationItemFields;
    bulkItem: TIhioDataAndPrescriptionMedicationItemFields;
    handleRemoveBulkItem: (UUID: string) => void
    setBulkItemFieldValues: React.Dispatch<React.SetStateAction<TIhioDataAndPrescriptionMedicationItemFields>>;
}

const BulkItemCardItem = ({
    bulkItemFieldValues,
    bulkItem,
    handleRemoveBulkItem,
    setBulkItemFieldValues
}: BulkItemCardItemProps) => {

    const handleEditBulkItem = () => {
        setBulkItemFieldValues(bulkItem)
    }

    return (
        <div
            className={`card rounded-4 shadow-none mt-3 px-3 pt-2 ${bulkItemFieldValues?.UUID === bulkItem?.UUID ? 'border-primary' : ''}`}
        >
            <div className={'d-flex justify-content-between align-items-center'}>
                <div className={'d-flex align-items-center'}>
                    <Tooltip alt={'حذف دارو'}>
                        <span>
                            <button
                                onClick={() => bulkItem?.UUID && handleRemoveBulkItem(bulkItem?.UUID)}
                                className="btn btn-danger rounded rounded-circle flex-grow-1 py-1 px-2 mx-1"
                            >
                                <Icon name={'trash'}/>
                            </button>
                        </span>
                    </Tooltip>
                    <Tooltip alt={'ویرایش دارو'}>
                        <span>
                            <button
                                onClick={handleEditBulkItem}
                                className="btn btn-primary rounded rounded-circle flex-grow-1 py-1 px-2 mx-1"
                            >
                                 <Icon name={'pen-square'}/>
                            </button>
                        </span>
                    </Tooltip>
                    <span>
                        {bulkItem?.item?.molecule}
                    </span>
                </div>
                <div className={'d-flex align-items-center'}>
                    <div
                        className={'bg-primary text-white rounded-4 py-2 px-3'}
                    >
                        {`مقدار ${bulkItem?.itemCount || 0}`}
                    </div>
                    {
                        bulkItem?.message?.warning?.map((item: string, index: number) => {
                            return (
                                <>
                                    <Tooltip alt={item}>
                                        <span className="d-flex align-content-center text-yellow font-20 me-2">
                                            <Icon name={'info-circle'}/>
                                         </span>
                                    </Tooltip>
                                </>
                            );
                        })
                    }
                    {
                        bulkItem?.message?.info?.map((item: string, index: number) => {
                            return (
                                <>
                                    <Tooltip alt={item}>
                                        <span className="d-flex align-content-center text-yellow font-20 me-2">
                                            <Icon name={'info-circle'}/>
                                        </span>
                                    </Tooltip>
                                </>
                            );
                        })
                    }
                </div>
            </div>
            <div className={'text-gray me-2 mt-1'}>
                {bulkItem?.drugDescription}
            </div>
            {
                bulkItem?.message?.error?.map((item: string) => {
                    return (
                        <div className='mt-2'>
                            <Alert
                                className={'border-dashed border-danger border-2'}
                                type={'danger'}
                                text={item}
                                icon={'user-cross'}
                            />
                        </div>
                    );
                })
            }
        </div>
    )
}


export default BulkItemCardItem;